import { render, staticRenderFns } from "./ParticipationCommentStatus.vue?vue&type=template&id=5e2485f2&"
import script from "./ParticipationCommentStatus.vue?vue&type=script&lang=js&"
export * from "./ParticipationCommentStatus.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationCommentStatus.vue?vue&type=style&index=0&id=5e2485f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports